import { WelcomeScreen } from "@excalidraw/excalidraw/index";
import React, { useEffect, useState } from "react";
import { ServerData } from "../data/ServerData";
import type { DrawingSummary } from "../data/ServerData";

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  isCollabEnabled: boolean;
  onOpenDrawing?: (id: string) => void;
  onNewDrawing?: () => void;
  onOpenLibraryBrowser?: () => void;
  userName?: string;
}> = React.memo((props) => {
  const [recentDrawings, setRecentDrawings] = useState<DrawingSummary[]>([]);

  useEffect(() => {
    ServerData.list()
      .then((drawings) => setRecentDrawings(drawings.slice(0, 4)))
      .catch(() => {});
  }, []);

  return (
    <WelcomeScreen>
      <WelcomeScreen.Hints.MenuHint>
        Export, preferences, libraries, and more
      </WelcomeScreen.Hints.MenuHint>
      <WelcomeScreen.Hints.ToolbarHint />
      <WelcomeScreen.Hints.HelpHint />
      <WelcomeScreen.Center>
        <WelcomeScreen.Center.Logo />
        <WelcomeScreen.Center.Heading>
          {props.userName ? `Welcome, ${props.userName.split(" ")[0]}` : "Surfboard Diagrams"}
        </WelcomeScreen.Center.Heading>
        <WelcomeScreen.Center.Menu>
          {props.onNewDrawing && (
            <WelcomeScreen.Center.MenuItemLoadScene />
          )}
          {props.onNewDrawing && (
            <WelcomeScreen.Center.MenuItem
              onSelect={props.onNewDrawing}
              shortcut={null}
              icon={
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 5v14M5 12h14" />
                </svg>
              }
            >
              New drawing
            </WelcomeScreen.Center.MenuItem>
          )}
          {props.onOpenLibraryBrowser && (
            <WelcomeScreen.Center.MenuItem
              onSelect={props.onOpenLibraryBrowser}
              shortcut={null}
              icon={
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
                </svg>
              }
            >
              Architecture libraries
            </WelcomeScreen.Center.MenuItem>
          )}
          <WelcomeScreen.Center.MenuItemHelp />
        </WelcomeScreen.Center.Menu>

        {recentDrawings.length > 0 && props.onOpenDrawing && (
          <div style={{
            marginTop: "20px",
            width: "100%",
            maxWidth: "480px",
          }}>
            <div style={{
              fontSize: "12px",
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              color: "var(--color-text-secondary, #999)",
              marginBottom: "8px",
              textAlign: "left",
            }}>
              Recent drawings
            </div>
            <div style={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              background: "var(--color-surface-low, #f5f5f5)",
              borderRadius: "8px",
              overflow: "hidden",
            }}>
              {recentDrawings.map((d) => (
                <button
                  key={d.id}
                  onClick={() => props.onOpenDrawing!(d.id)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 14px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "var(--color-text-primary, #333)",
                    textAlign: "left",
                    width: "100%",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = "var(--color-surface-mid, #eee)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = "none";
                  }}
                >
                  <span style={{ fontWeight: 500 }}>{d.name}</span>
                  <span style={{
                    fontSize: "11px",
                    color: "var(--color-text-secondary, #999)",
                  }}>
                    {new Date(d.updated_at + "Z").toLocaleDateString(undefined, {
                      month: "short",
                      day: "numeric",
                    })}
                  </span>
                </button>
              ))}
            </div>
          </div>
        )}
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
